import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { FileInput } from "~/components/file-input";

interface ControlledFileInputProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  accept?: string;
  maxSize?: number;
  recommendedDimensions?: { width: number; height: number };
  uploadLabel?: string;
  previewType?: "image" | "none";
  placeholder?: string;
  disabled?: boolean;
}

export function ControlledFileInput<T extends FieldValues>({
  control,
  name,
  accept = "image/*",
  maxSize,
  recommendedDimensions,
  uploadLabel,
  previewType = "image",
  placeholder,
}: ControlledFileInputProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ...field } }) => (
        <FileInput
          {...field}
          value={value || ""}
          type="url"
          accept={accept}
          maxSize={maxSize}
          recommendedDimensions={recommendedDimensions}
          uploadLabel={uploadLabel}
          previewType={previewType}
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        />
      )}
    />
  );
}
